export class CreateTemplateRequest{
  public descripcion!:string
  public nombre!:string
  public content!:string
}
